import BaseLayout from "layouts/base-layout";
import React from "react";
import RenderModules from "helpers/render-modules";
import Image from "components/image";
import formatDate from "helpers/format-date";
import { formatTitle } from "helpers/format-title";

export { Head } from "components/head";

const Blog = ({ pageContext, location }) => {
	const { modules, excerpt, featuredImage, date, language, header, footer, title, breadcrumbs, pageSettings } = pageContext;

	return (
		<BaseLayout
			path={location.pathname}
			header={header}
			footer={footer}
			breadcrumbs={breadcrumbs}
			title={title}
			pageSettings={pageSettings}
		>
			<div className="px-4 md:px-7.5 box-border">
				<div className="flex justify-center flex-col m-auto w-full md:w-3/4 lg:w-1/2 text-center gap-7 my-10">
					<span className="text-gray-500">{formatDate(date, language)}</span>
					<h1 className="text-h2-xs md:text-h2 font-heading">{formatTitle(title)}</h1>
					<p>{excerpt}</p>
				</div>
				<div className="w-full h-[300px]">
					<Image className="w-full aspect-video h-full" image={featuredImage} alt={featuredImage?.alt} />
				</div>

				<div className="blog-modules">
					{modules?.length > 0 && <RenderModules modules={modules} />}
				</div>
			</div>

		</BaseLayout>
	);
};

export default Blog;
